import React, { Component, } from 'react';
import { object, func, string, } from 'prop-types';
import { connect, } from 'react-redux';
import Grid from '@material-ui/core/Grid';

import Widget from '../../../legacy-tv-ui/Widget';

import fetchSymbolDetail from '../actions/fetchSymbolDetail';
import ReturnVol from './ReturnVol';
import CummulativeReturn from './CummulativeReturn';

export class Panel extends Component {
  static propTypes = {
    symbolSummary: object.isRequired,
    fetchSymbolDetail: func.isRequired,
    token: string.isRequired,
    company: string.isRequired,
    report: string.isRequired,
    year: string.isRequired,
    month: string.isRequired,
    interval: string.isRequired,
  }
  static defaultProps = {}
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const {
      year,
      month,
      report,
      fetchSymbolDetail,
      symbolSummary,
      // interval,
      token,
      company,
    } = this.props;
    const allIds = symbolSummary[year][month][report].all;
    // const selectedIds = symbolSummary[year][month][report].selected;
    fetchSymbolDetail(company, year, month, token, allIds, report);
  }
  render() {
    const {
      year,
      month,
      report,
      symbolSummary,
      interval,
    } = this.props;
    const allIds = symbolSummary[year][month][report].all;
    const selectedIds = symbolSummary[year][month][report].selected;
    const { symbolDetail } = symbolSummary[year][month];
    return (
      <div>
        {
          symbolDetail &&
          <div>
            <Grid
              item
              xs={12}
              style={{
                padding: 20,
              }}
            >
              <Widget title="所有標的">
                <ReturnVol
                  symbolDetail={symbolDetail}
                  selectedIds={selectedIds}
                  allIds={allIds}
                  interval={interval}
                />
              </Widget>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                padding: 20,
              }}
            >
              <Widget
                title="投資組合標的累積報酬率"
                style={{
                  minHeight: 400,
                }}
              >
                <CummulativeReturn
                  symbolDetail={symbolDetail}
                  selectedIds={selectedIds}
                  interval={interval}
                />
              </Widget>
            </Grid>
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    symbolSummary: state.symbolSummary,
    token: state.appState.userToken,
    company: state.appState.company,
  };
}

const dispatchObj = {
  fetchSymbolDetail,
};

export default connect(mapStateToProps, dispatchObj)(Panel);



// WEBPACK FOOTER //
// ./src/scenes/SymbolSummary/components/Panel.js